import React, { useEffect } from "react";

import { Skeleton, Stack, Typography } from "@mui/material";
import { Feed, GettingStarted, MarketIntelligence, SocialNetwork } from "components/Dashboard";
import { DashboardKpiCard } from "components/Dashboard/Kpi-card/DashboardKpiCard";
import { FreemiumUpgradeCard } from "components/Sidebar/Sidebar-components/Freemium-upgrade-card";
import { useActionHook, useModals } from "hooks";
import { useAccountSelector, useReportsActions, useReportsQueriesSelector } from "store";
import { CubicData } from "store/types";

import "./Dashboard.styles.scss";

export const Dashboard: React.FC = () => {
  const { is_freemium, allow_social } = useAccountSelector() || {};
  const { openUpgradePlanModal } = useModals();

  const { getCubicAction } = useReportsActions();
  const { cubicDashboard, exchangeMethod, currency, dateRange, use_accounting_date } = useReportsQueriesSelector();

  const {
    data: cubicData,
    loading: cubicLoading,
    error: cubicError,
    action: getCubic
  } = useActionHook(getCubicAction);

  useEffect(() => {
    if (Object.keys(cubicDashboard).length) {
      getCubic({
        cubics: cubicDashboard,
        pageType: "cubicDashboard",
        filters: {},
        exchangeMethod,
        currency,
        dateRange,
        use_accounting_date
      });
    }
  }, [cubicDashboard, dateRange, exchangeMethod, currency, use_accounting_date]);

  return (
    <Stack direction="column" sx={{ width: "100%", gap: "16px", pb: "16px" }}>
      {is_freemium && (
        <Stack
          direction="row"
          alignItems="stretch"
          sx={{
            gap: "10px",
            width: "100%",
            height: "216px",
            "@media (max-width: 1100px)": {
              flexWrap: "wrap",
              height: "auto"
            }
          }}
        >
          <GettingStarted />
          <FreemiumUpgradeCard
            onUpgrade={openUpgradePlanModal}
            sx={{
              height: "216px",
              width: is_freemium ? "20%" : "100%",
              minWidth: "270px",
              flexShrink: 0,
              "@media (max-width: 1100px)": {
                width: "100%",
                minWidth: "unset"
              }
            }}
          />
        </Stack>
      )}

      <Stack direction="row" sx={{ gap: "10px", justifyContent: "space-between", width: "100%" }}>
        {cubicLoading ? (
          <>
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rounded"
                animation="wave"
                sx={{
                  flex: "1 0 0",
                  borderRadius: "8px",
                  height: "90px"
                }}
              />
            ))}
          </>
        ) : cubicError ? (
          <Typography variant="body1" sx={{ color: "#496682", py: "8px" }}>
            Portfolio data could not be loaded. Refresh the page or contact support if the issue persists.
          </Typography>
        ) : !cubicData ? (
          <Typography variant="body1" sx={{ color: "#496682", py: "8px" }}>
            No portfolio data found.
          </Typography>
        ) : (
          Object.entries(cubicData)
            .filter(([, item]) => Boolean(item))
            .map(([key, item]: [string, CubicData]) => {
              console.log(item, item, item)
              return <DashboardKpiCard key={key} item={item} name={key} isLoading={cubicLoading} />
            })
        )}
      </Stack>
      <Stack direction="row" gap="10px" alignItems="stretch" sx={{ width: "100%" }}>
        <Feed sx={{ width: "70%", maxHeight: "545px" }} />
        <MarketIntelligence sx={{ width: "30%", minWidth: "400px" }} />
      </Stack>
      {/* <YourDeals /> */}
      {!!allow_social && <SocialNetwork />}
    </Stack>
  );
};
